"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _alloyReactNotification = require("@adsk/alloy-react-notification");
var _alloyReactLocale = require("@adsk/alloy-react-locale");
var _alloyReactPanel = _interopRequireDefault(require("@adsk/alloy-react-panel"));
var _i18n = require("../../../i18n");
var _Modal = require("../../Modal");
var _constants = require("../constants");
var _hooks = require("../hooks");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
var _ReportNotifications = _interopRequireDefault(require("./ReportNotifications"));
var _PanelBody = _interopRequireDefault(require("./PanelBody"));
var _ContentPages = require("./ContentPages");
var _SuccessPanel = _interopRequireDefault(require("./SuccessPanel"));
var _ProgressSpinnerPanel = _interopRequireDefault(require("./ProgressSpinnerPanel"));
var _FormPanel = _interopRequireDefault(require("./FormPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const QuickReportsPanelContainer = _ref => {
  let {
    isOpen,
    service,
    templates,
    options,
    accountId,
    projectId,
    onClose,
    openedFrom,
    onCustomizeComponents,
    itemCount,
    onReportSubmit,
    onReportComplete,
    customSubtext,
    onChange,
    ...rest
  } = _ref;
  const {
    type: initialType,
    title: initialTitle,
    formats: initialFormats
  } = templates[0];
  const {
    T
  } = (0, _i18n.useTranslation)();
  const [reportTitle, setReportTitle] = (0, _react.useState)(initialTitle);
  const [currentType, setCurrentType] = (0, _react.useState)(initialType);
  const [currentFormat, setCurrentFormat] = (0, _react.useState)(initialFormats[0]);
  const [isTitleEdited, setIsTitleEdited] = (0, _react.useState)(false);
  const [reportComponents, setCurrentComponents] = (0, _react.useState)();
  const [reportId, setReportId] = (0, _react.useState)();
  const [activePageName, setActivePageName] = (0, _react.useState)(_constants.PAGES.FORM);
  const [reportUrl, setReportUrl] = (0, _react.useState)();
  const [saveOptions, setSaveOptions] = (0, _react.useState)({});
  const isFormValid = (0, _hooks.useIsFormValid)(reportTitle);
  const contextValue = {
    isOpen,
    reportService: service,
    reportTitle,
    reportType: currentType,
    reportFormat: currentFormat,
    reportFields: isTitleEdited,
    reportComponents,
    isFormValid,
    itemCount,
    saveOptions,
    setSaveOptions,
    setReportTitle,
    setCurrentType,
    setCurrentFormat,
    setCurrentComponents,
    setIsTitleEdited,
    setReportId,
    setReportUrl,
    onCustomizeComponents
  };
  (0, _react.useEffect)(() => {
    onChange({
      type: currentType,
      title: reportTitle,
      format: currentFormat
    });
  }, [currentType, reportTitle, currentFormat]);
  const {
    trackOpen,
    trackClose,
    trackBeforeSubmit
  } = (0, _hooks.useTrackEvent)(contextValue);
  (0, _hooks.useResetOnClose)({
    context: contextValue,
    templates,
    activePageName
  }, () => {
    setActivePageName(_constants.PAGES.FORM);
  });
  (0, _hooks.useTrackOpenLoadEvent)({
    trackEvent: trackOpen,
    isOpen,
    openedFrom
  });
  return /*#__PURE__*/_react.default.createElement(_QuickReportsPanelContext.default.Provider, {
    value: contextValue
  }, /*#__PURE__*/_react.default.createElement(_Modal.ModalProvider, null, /*#__PURE__*/_react.default.createElement(_alloyReactNotification.NotificationsProvider, null, /*#__PURE__*/_react.default.createElement(_ReportNotifications.default, {
    accountId: accountId,
    projectId: projectId,
    reportId: reportId,
    setActivePageName: setActivePageName,
    setReportUrl: setReportUrl,
    setReportId: setReportId,
    onReportComplete: onReportComplete
  }, /*#__PURE__*/_react.default.createElement(_alloyReactLocale.LocaleProvider, null, /*#__PURE__*/_react.default.createElement(_alloyReactPanel.default, _extends({
    open: isOpen,
    title: T.translate('panelTitle'),
    onClose: trackClose(onClose),
    options: options
  }, rest), /*#__PURE__*/_react.default.createElement(_PanelBody.default, null, /*#__PURE__*/_react.default.createElement(_ContentPages.ContentPages, {
    activePageName: activePageName
  }, /*#__PURE__*/_react.default.createElement(_ContentPages.ContentPage, {
    name: _constants.PAGES.SUCCESS
  }, /*#__PURE__*/_react.default.createElement(_SuccessPanel.default, {
    reportUrl: reportUrl
  })), /*#__PURE__*/_react.default.createElement(_ContentPages.ContentPage, {
    name: _constants.PAGES.LOADING
  }, /*#__PURE__*/_react.default.createElement(_ProgressSpinnerPanel.default, null)), /*#__PURE__*/_react.default.createElement(_ContentPages.ContentPage, {
    name: _constants.PAGES.FORM
  }, /*#__PURE__*/_react.default.createElement(_FormPanel.default, {
    accountId: accountId,
    projectId: projectId,
    options: options,
    templates: templates,
    beforeSubmit: trackBeforeSubmit({
      ...options,
      components: reportComponents
    }, () => setActivePageName(_constants.PAGES.LOADING)),
    onSubmitComplete: report => report ? setReportId(report.id) : setActivePageName(_constants.PAGES.FORM),
    onValidationError: () => setActivePageName(_constants.PAGES.FORM),
    onReportSubmit: onReportSubmit,
    customSubtext: customSubtext
  }))))))))));
};
QuickReportsPanelContainer.defaultProps = {
  onClose: () => {},
  floating: true,
  onCustomizeComponents: components => components,
  onReportSubmit: () => {},
  onReportComplete: () => {},
  onChange: () => {}
};
QuickReportsPanelContainer.propTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func,
  floating: _propTypes.default.bool,
  service: _propTypes.default.string.isRequired,
  templates: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    formats: _propTypes.default.arrayOf(_propTypes.default.oneOf(['pdf', 'excel'])),
    disabled: _propTypes.default.bool,
    info: _propTypes.default.string
  })).isRequired,
  openedFrom: _propTypes.default.string,
  options: _propTypes.default.shape({
    fields: _propTypes.default.array,
    components: _propTypes.default.array,
    filter: _propTypes.default.array,
    sort: _propTypes.default.array,
    group: _propTypes.default.array,
    custom: _propTypes.default.object
  }),
  accountId: _propTypes.default.string,
  projectId: _propTypes.default.string,
  onCustomizeComponents: _propTypes.default.func,
  itemCount: _propTypes.default.number,
  onReportSubmit: _propTypes.default.func,
  onReportComplete: _propTypes.default.func,
  customSubtext: _propTypes.default.string,
  onChange: _propTypes.default.func
};
var _default = exports.default = QuickReportsPanelContainer;